module.exports = __webpack_public_path__ + "static/img/daan.c0892c77.png";